module.exports = __webpack_public_path__ + "media/partners/norauto2x-a38d2cc2.png";